define.alias("checkout/components/checkout-button", "calendar/components/checkout-button");